import { ROLES_DESCRIPTION, ROLES } from '../constants';

const defaultZeroHandler = {
  get(obj, prop) {
    return prop in obj ? obj[prop] : ROLES.NOT_AUTHENTICATED;
  }
};

const roleMap = new Proxy(
  {
    'CompliSpace Administrator': 4,
    'Group Administrator': 3,
    'Client Administrator': 2,
    'Client User': 1
  },
  defaultZeroHandler
);

function getRoleLevel(string) {
  return roleMap[string];
}

function getRoleDescription(level) {
  const role = Object.keys(roleMap).find((key) => getRoleLevel(key) === level);

  return role || ROLES_DESCRIPTION.NOT_AUTHENTICATED;
}

export { getRoleLevel, getRoleDescription };
